//React
import React from 'react';

//Material-ui
import Button from '@material-ui/core/Button';
import IconButton from '@material-ui/core/IconButton';
import Dialog from '@material-ui/core/Dialog';


//Icon

import CloseIcon from '@material-ui/icons/Close';




class Comp extends React.Component {

	render() {
		return (

        <Dialog
          open={this.props.open}
          onClose={ () => this.props.close() }
          style={{maxWidth:'600px', margin:'auto'}}
        >
          <div
            style={{
              display:'flex',
              flexDirection:'row',
              alignItems:'center',
              justifyContent:'space-between',
            }}
          >
            <div style={{fontSize:'1.1em',fontWeight:'bold',margin:'15px'}}>
              { this.props.title }
            </div>
            <IconButton
              onClick={ () => this.props.close() }
            >
              <CloseIcon/>
            </IconButton>
          </div>
          <div style={{margin:'10px'}}>
            { this.props.content }
          </div>
					{
						(this.props.apply) && (
							<div style={{margin:'10px'}} align='right'>
		            <Button
		              variant="contained"
		              color="primary"
		              style={{fontSize:'1.1em',margin:'5px'}}
		              onClick={ () => this.props.apply() }
		            >
		              はい
		            </Button>
		          </div>
						)
					}


        </Dialog>

		)
	}
}



export default Comp;
